var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUncover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2292 2H9.77082C5.47911 2 2 5.47912 2 9.77083V44.2292C2 48.5209 5.47911 52 9.77082 52H44.2292C48.5209 52 52 48.5209 52 44.2292V9.77083C52 5.47912 48.5209 2 44.2292 2Z",
    stroke: "#19292C",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 18.3859V20.5421",
    stroke: "#19292C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 35.6151V33.4692",
    stroke: "#19292C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.766 23.5525C30.6514 21.8702 29.266 20.5369 27.5576 20.5369H26.2399C24.568 20.5369 23.2139 21.891 23.2139 23.5629C23.2139 24.9483 24.1566 26.1567 25.5003 26.4952L28.4951 27.5056C29.8389 27.8442 30.7816 29.0525 30.7816 30.4379C30.7816 32.1098 29.4274 33.464 27.7556 33.464H26.4378C24.7243 33.464 23.3389 32.1254 23.2295 30.4431",
    stroke: "#19292C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 27.0001C11.75 18.5782 18.5781 11.7501 27 11.7501C35.4219 11.7501 42.25 18.5782 42.25 27.0001C42.25 35.422 35.4219 42.2501 27 42.2501C20.8854 42.2501 15.6094 38.6512 13.1823 33.4533",
    stroke: "#19292C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncover);
export default __webpack_public_path__ + "static/media/uncover.4e014dfebecb2bcff93d7906c176bf21.svg";
export { ForwardRef as ReactComponent };